import { useAuthStore } from "@/stores/use-auth-store";
import Echo from "laravel-echo";
import Pusher from "pusher-js/react-native";

let echoInstance = null;

export function getEcho() {
  if (echoInstance) return echoInstance;

  const token = useAuthStore.getState().token;
  if (!token) {
    console.error("No token available for WebSocket connection");
    return null;
  }

  const pusher = new Pusher(process.env.EXPO_PUBLIC_REVERB_APP_KEY, {
    wsHost: process.env.EXPO_PUBLIC_REVERB_HOST || "0.0.0.0",
    wsPort: Number(process.env.EXPO_PUBLIC_REVERB_PORT || 8080),
    wssPort: Number(process.env.EXPO_PUBLIC_REVERB_PORT || 443),
    forceTLS: (process.env.EXPO_PUBLIC_REVERB_SCHEME || "https") === "https",
    enabledTransports: ["ws", "wss"],
    cluster: "mt1",
    authEndpoint: `${process.env.EXPO_PUBLIC_API_URL}/api/broadcasting/auth`,
    disableStats: true,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });

  echoInstance = new Echo({
    broadcaster: "reverb",
    client: pusher,
  });

  return echoInstance;
}

export function resetEcho() {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
}
